/* — top-bar pill — */
.pill {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 12px;
  border: 1px solid var(--color-divider);
  border-radius: var(--radius-sm);
  background: transparent;
  font-family: var(--font-heading);
  font-size: 13px;
  font-weight: 700;
  color: var(--color-neutral-700);
  font-variant-numeric: tabular-nums;
  cursor: pointer;
}
.pill:hover:not(:disabled) {
  background: var(--color-accent-100);
  color: var(--color-accent-700);
}
.pill:disabled {
  cursor: default;
}
.pillDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-neutral-400);
}
.pillOn {
  border-color: var(--color-danger);
  background: var(--color-danger);
  color: #ffffff;
}
.pillOn:hover:not(:disabled) {
  background: var(--color-danger-700);
  color: #ffffff;
}
.pillOn .pillDot {
  background: #ffffff;
  animation: evx-pulse 1s infinite;
}

/* — panel — */
.backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 32, 44, 0.5);
  animation: evx-fadeUp 0.2s ease both;
}
.panel {
  width: 500px;
  padding: 30px 34px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}
.title {
  margin: 0;
  font-weight: 800;
  color: var(--color-text);
}
.readout {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  background: var(--color-neutral-100);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
}
.state {
  padding: 4px 12px;
  border-radius: var(--radius-sm);
  background: var(--color-neutral-300);
  color: var(--color-text);
  font-weight: 800;
  font-size: 18px;
}
.stateOn {
  background: var(--color-danger);
  color: #ffffff;
}
.metric {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-neutral-700);
  font-variant-numeric: tabular-nums;
}
.note {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-neutral-600);
}
.durations {
  display: flex;
  gap: 10px;
  border: 0;
  margin: 0;
  padding: 0;
}
.durations legend {
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 700;
  color: var(--color-accent-700);
}
.duration {
  flex: 1;
  padding: 10px 0;
  border: 2px solid var(--color-divider);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 15px;
  color: var(--color-text);
  cursor: pointer;
}
.duration[aria-checked='true'] {
  border-color: var(--color-accent);
  background: var(--color-accent-100);
  color: var(--color-accent-700);
}
.duration:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.confirm {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text);
  cursor: pointer;
}
.confirm input {
  width: 22px;
  height: 22px;
  accent-color: var(--color-danger);
}
.error {
  padding: 10px 14px;
  background: var(--color-danger-100);
  color: var(--color-danger-700);
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 700;
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.close {
  margin-right: auto;
}
